<template>

    <v-modal title="Edit Link">
        <template #body>
            <form @submit.prevent="submit">
                <v-textarea id="link" class="mb-10" size="sm" placeholder="http://" :model="params.link" @input="params.link = $event" />
                <v-select size="sm" :model="params.type" @input="params.type = $event">
                    <option value="">Website</option>
                    <option value="mailto">Email Address</option>
                    <option value="tel">Phone Number (Voice)</option>
                    <option value="sms">Phone Number (SMS)</option>
                </v-select>
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="dismiss">Cancel</v-button>
            <v-button size="sm" @click.native="submit">Apply</v-button>
        </template>
    </v-modal>

</template>

<script>

import Modal from './Modal';

export default {

    components: {
        'v-modal': Modal,
    },

    data() {
        return {
            params: {},
        }
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

        modalParams() {
            return this.$store.getters['builder/selectedModalParams'];
        },

        selectedLink() {
            return this.modalParams.link;
        },

        selectedType() {
            if (this.selectedLink?.startsWith('mailto:')) return 'mailto';
            if (this.selectedLink?.startsWith('tel:')) return 'tel';
            if (this.selectedLink?.startsWith('sms:')) return 'sms';
            return '';
        },

    },

    created() {
        this.params.link = this.selectedLink?.replace(/^(mailto:|tel:|sms:)/gi, '');
        this.params.type = this.selectedType;
    },

    mounted() {
        document.getElementById('link').focus();
    },

    methods: {

        submit() {
            let link = this.params.link;
            if (this.params.type === 'mailto') link = `mailto:${this.params.link}`;
            if (this.params.type === 'tel') link = `tel:${this.params.link}`;
            if (this.params.type === 'sms') link = `sms:${this.params.link}`;
            if (this.modalParams.target) {
                this.modalParams.target.setAttribute('href', link);
            } else if (this.modalParams.range) {
                this.createLink(link);
            }
            this.dismiss();
        },

        createLink(link) {
            let sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(this.modalParams.range);
            document.execCommand('CreateLink', false, link);
            if (this.block) {
                document.execCommand('ForeColor', false, this.block.link_color);
            }
            sel.empty();
        },

        unlink() {
            let sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(this.modalParams.range);
            document.execCommand('unlink', false);
            sel.empty();
        },

        dismiss() {
            this.$store.commit('builder/setSelectedModal', null);
        },

    },

}

</script>